import { BankSyncSection } from '@/components/BankSyncSection';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function BankSyncPage() {
  const navigate = useNavigate();

  return (
    <div className="px-4 pt-6 pb-4">
      <div className="mb-4 flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={() => navigate('/more')}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="font-display text-xl font-bold">Bank Sync</h1>
      </div>
      <BankSyncSection />
    </div>
  );
}
